import styled from "styled-components";

export const PageLocationTitle = styled.h1`
  color: rgb(25, 31, 40);
  text-transform: uppercase;
  font-size: 24px;
  width: 100%;
  font-weight: 600;
`;

export const SummaryCard = styled.div`
  background-color: #ffffff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0px 9px 16px rgba(159, 162, 191, 0.18),
    0px 2px 2px rgba(159, 162, 191, 0.32);
`;

export const SummaryValue = styled.span`
  font-size: 28px;
  font-weight: 700;
  color: #223354;
`;

export const SummaryLabel = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: rgb(132, 140, 155);
  text-transform: uppercase;
`;

export const ChartContainer = styled.div`
  background-color: #ffffff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0px 9px 16px rgba(159, 162, 191, 0.18),
    0px 2px 2px rgba(159, 162, 191, 0.32);
  min-height: 350px;
`;
